import React, { useState} from 'react';
import * as S from './styles';
import C from '@assets/themes/colors';
import { IProps } from './types';
import { storageAccountName, containerNameBrands } from '@storage/azure-storage-blob';
import Loading from '@components/Loading';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { IBrandImage } from '@state/brandsImages/types';
import { cloneDeep } from 'lodash';
import { getWidthHeightFromSrc } from '@utils/userUtils';

const ImagesList: React.FC<IProps> = (props) => {
  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;
  let selectedRefs = React.useRef([] as any);

  const renderLoaderContainer = () => {
    if (props.isLoading)
      return(
        <S.LoaderContainer>
          <Loading 
            id={"loading-designs"}
            containerStyle={{justifyContent: 'center'}}
          />
        </S.LoaderContainer>
      );
  }

  const getImageSrc = (data:IBrandImage)=>{    

    if (data.id=="" || data.id== undefined)
      return data.srcImage;
    else
    {      
      return `${urlBrand}/${data.brandId}/${data.imageType.toLowerCase()}/${data.srcImage}` + "TN";
    }

  }

  const getDescription = (data: any) => {
    let description: string = ""; 
    if (data.make) description += `${data.make}, `;
    if (data.model) description += `${data.model}, `;
    if (data.year) description += `${data.year}, `;

    if (data.types && data.types.length>0) 
        data.types.forEach((type: any) => {
          if (type.value) description += `${type.value}, `}
        );
    if (description.length>0) description = description.substring(0, description.length - 2);
    return description;
  }

  const getContainerHeight = () => {
    let search : number = props.searching ? 34:0;
    return !props.category || props.category==="vehicle" ? 450 + search :385 + search ;
  }

  const getOpacity = (data: any) => {
    if(!props.loadFromBrand) return;
    else {
      return data.width && data.height ? '1' : 
      data.status === 'uploading' ? '0.75' :'0';
    }
  }

  const onSelect = async (index: number, data: any) => {
    props.setSelectedIndex(index); 
    /*if (props.loadFromBrand) {
      let srcFileOrg= `${urlBrand}/${data.brandId}/${data.imageType?data.imageType.toLowerCase():""}/${data.srcImage}`;
      const dimensionsOrg = await getWidthHeightFromSrc(srcFileOrg ?? "");
      if (dimensionsOrg) {
        data.initWidth = dimensionsOrg.width;
        data.initHeight = dimensionsOrg.height;
      }
    }*/
    props.setSelectedData(cloneDeep(data));
  }

  return (
    <>   
        {
        (props.imagesList && props.imagesList.length > 0) || props.isLoading ?
        <S.DesignsContainer id="infinite-scroll-all-vehicles" onScroll={(e: any)=> props.onScroll(e)}  onMouseDown={()=>props.setAllowClean(true)} marginTop={props.category ? "45px" : "10px"} height={getContainerHeight()}>
        <S.DesignsWrap flex={true}>
          <TransitionGroup className="group-list" id="design-list">
            {
              props.imagesList && props.imagesList.length > 0 &&
              props.imagesList.map((data: any, index: number) => {
                return (
                  <CSSTransition key={index} timeout={600} classNames="item">
                    <div ref={props.selectedIndexes.includes(index) ? ref=>selectedRefs.current.push(ref) : null}>
                      <S.PreviewContainer selected={index==props.selectedIndex}>
                        <S.ImgContainer 
                          height={86} src={getImageSrc(data)} 
                          onClick={()=>{onSelect(index, data);}}  
                          transparent={ !(!props.category || props.category==="vehicle") ? true : data.types && data.types.length>0 && data.types[0].value==="Jellybean"}/>
                        <S.ImgTitle >
                          {getDescription(data)}
                        </S.ImgTitle>
                      </S.PreviewContainer>
                    
                    </div>
                  </CSSTransition>
                )
              })
            }
          </TransitionGroup>                            
        </S.DesignsWrap>
        {
          renderLoaderContainer()
        }
        </S.DesignsContainer>
        :
        <S.EmptyContainer>
        <p style={{width:'448px'}}>Once you complete the required fields, you will be shown images matching your search.</p>               
        <p>From there, you can select the one you need</p>
        </S.EmptyContainer>
          }
    </>
  );
}

export default ImagesList;